import React, { ReactElement, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Typography } from 'antd'
import { ExpandCollapseChevronButton } from '../../../../../Components/UI'
import { ProposalCardContent } from './ProposalCardContent'
import { s } from './style'
import {
  ProposalCardEventFragment,
  ProposalCardProposalFragment,
} from './ProposalCard.generated-types'
import { HasPreferredVenueContentWrapper } from './HasPreferredVenueContentWrapper/HasPreferredVenueContentWrapper'

const { Text } = Typography

interface ProposalCardProps {
  event: ProposalCardEventFragment
  proposal: ProposalCardProposalFragment
  expanded?: boolean
  handleExpandCollapse?: () => void
  responseIndex?: number
  refetchEvent?: () => void
}

export const ProposalCard: FC<ProposalCardProps> = ({
  event,
  proposal,
  expanded = true,
  handleExpandCollapse,
  responseIndex,
  refetchEvent,
}): ReactElement => {
  const { t } = useTranslation()

  const showOtherHead = t('eventHub.inProgress.response.showOtherHead', 'Show')
  const showOtherTail = t('eventHub.inProgress.response.showOtherTail', 'other responses')

  return (
    <div style={{ top: expanded ? 0 : -98 * responseIndex, ...s.wrapper }}>
      <Card bodyStyle={s.card}>
        {expanded ? (
          <HasPreferredVenueContentWrapper proposal={proposal}>
            <ProposalCardContent event={event} proposal={proposal} />
          </HasPreferredVenueContentWrapper>
        ) : (
          <div style={s.collapsed}>
            <ExpandCollapseChevronButton
              expanded={expanded}
              handleExpandCollapse={handleExpandCollapse}
            />
            <Text strong>{`${showOtherHead} ${responseIndex + 1} ${showOtherTail}`}</Text>
          </div>
        )}
      </Card>
    </div>
  )
}
